import React from 'react';
import {connect} from 'react-redux';
import './basket.css';



const Basket=({total_price , count_cart})=>{

    return(
        <div className="basket-header" id="basket-header">
            <i className="fa fa-shopping-basket basket-i"></i>
            <span className="basket-count">
                {count_cart} items
            </span>
            <span className="basket-cost">
            (${total_price})
            </span>
        </div>
    );
    
}


const mapStateToProps=({total_price , count_cart})=>{
    return{
        total_price,
        count_cart,
    }
}

export default connect(mapStateToProps)(Basket);